import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CgEditHighlight } from "react-icons/cg";
import "./happenings.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const Happenings = () => {
  const navigate = useNavigate();
  const [happenings, setHappenings] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchHappenings = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/latest-news/public`);
        const data = await res.json();
        setHappenings(data.happenings || []);
      } catch (err) {
        console.error("Error fetching happenings:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHappenings();
  }, []);

  // const groupedHappenings = Object.values(
  //   happenings.reduce((acc, item) => {
  //     const order = item.display_order || 0;
  //     if (!acc[order]) acc[order] = item;
  //     return acc;
  //   }, {}),
  // ).sort((a, b) => b.id - a.id);
  const groupedHappenings = Object.values(
    happenings.reduce((acc, item) => {
      const order = item.display_order || 0;

      if (
        !acc[order] ||
        Number(item.id) > Number(acc[order].id)
      ) {
        acc[order] = item;
      }

      return acc;
    }, {})
  ).sort((a, b) => Number(b.id) - Number(a.id));

  return (
    <div className="happenings-wrapper">
      <h1 className="title">Happenings</h1>
      <hr className="divider" />

      {loading ? (
        <p>Loading...</p>
      ) : happenings.length === 0 ? (
        <p>No happenings available.</p>
      ) : (
        <div className="happenings-grid">
          {groupedHappenings.map((item) => {
            const photos = Array.isArray(item.news_photo)
              ? item.news_photo
              : [];

            return (
              <div key={item.id} className="happening-card">
                <div className="happening-top">
                  <CgEditHighlight className="happening-icon" />
                  <h3 className="happening-heading">{item.news_title}</h3>

                  {item.news_date && (
                    <p className="happenings-date" style={{ marginLeft: "auto" }}>{item.news_date}</p>
                  )}
                </div>
                <div className="happening-images">
                  {photos.length > 0 && (
                    <img
                      src={`${API_BASE}${photos[0]}`}
                      alt={item.news_title}
                    />
                  )}
                </div>
                <p>{item.description?.split(" ").slice(0, 40).join(" ")}...</p>

                <button
                  className="know-more-btn"
                  onClick={() =>
                    navigate(`/lifeatcampus/happenings/${item.id}`)
                  }
                >
                  Know More
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Happenings;
